export class ProcessingTime {
  private time: number;
  private constructor(time: number) {
    this.time = time;
  }

  static fromMiliseconds(time: number) {
    return new ProcessingTime(time);
  }

  static fromTimeInterval(start: Date, end: Date) {
    return new ProcessingTime((end.getTime() - start.getTime()) / 1000);
  }

  toSecondsText() {
    const unitAsText = this.time === 1 ? 'second' : 'seconds';

    return `${this.time} ${unitAsText}`;
  }
}
